import { render, staticRenderFns } from "./KioskPaymentSplit.vue?vue&type=template&id=45011553&scoped=true"
import script from "./KioskPaymentSplit.vue?vue&type=script&lang=js"
export * from "./KioskPaymentSplit.vue?vue&type=script&lang=js"
import style0 from "./KioskPaymentSplit.vue?vue&type=style&index=0&id=45011553&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45011553",
  null
  
)

export default component.exports